import { isDev } from 'pmt-modules/environment'

export const getInactivityTimeout = () => isDev() ? 10000000 : 60000
